module.exports = __webpack_public_path__ + "img/icon_list.64d099e1.svg";